module.exports = {"150428100":"锦山镇","150428101":"美林镇","150428102":"王爷府镇","150428103":"小牛群镇","150428104":"牛家营子镇","150428105":"乃林镇","150428106":"西桥镇","150428200":"十家满族乡","150428201":"南台子乡","150428400":"乃林果树农场","150428401":"马鞍山羊场","150428402":"赤峰市和美工贸园区","150428403":"锦山工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150428.json
// module id = 424
// module chunks = 0